import { BarChartPopupComponent } from './bar-chart-popup/bar-chart-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import {
  Component,
  OnInit,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';
import * as c3 from 'c3';
import { DataAnalyticsHelperService } from '../../services/data-analytics-helper.service';
import { DataAnalyticsService } from '../../services/data-analytics.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, OnDestroy {
  @Input() factorySummary: any;

  data: any;
  chart: any = null;
  colorList = ['#D26999', '#8F82C7', '#82C7C2', '#72A8D5', '#D26999'];
  isLoading = false;
  lineId: string;
  message: string;
  subscription: Subscription;

  costContributionByABCDSubscription: Subscription;

  constructor(
    private elRef: ElementRef,
    public dialog: MatDialog,
    private helper: DataAnalyticsHelperService,
    private requester: DataAnalyticsService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe(params => {
      if (params.level && params.factory && params.level && params.level === 'line') {
        this.lineId = (params.LineId) ? params.LineId : null;
        this.getChartData();
      }
    });
  }


  getChartData() {
    this.isLoading = true;
    this.message = 'Loading...';
    const req = {
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      FactoryId: this.factorySummary.factoryId,
      LineId: this.lineId,
      Level: 'line',
    };

    this.costContributionByABCDSubscription = this.requester.getCostContributionByABCD(req)
      .subscribe(res => {
        if (res && res.length > 0) {
          this.isLoading = false;
          this.data = this.helper.CCbarData(res);
          this.generateChart();

        } else {
          this.message = 'Data not available';
          if (this.chart) {
            this.chart.destroy();
          }
        }
      });
  }

  generateChart() {
    this.chart = c3.generate({
      bindto: this.elRef.nativeElement.children[0].children[1],
      padding: {
        top: 0,
        right: 10,
        bottom: 20
      },
      data: {
        json: this.data,
        keys: { //
          x: 'label', //
          value: ['val'], //
        }, //
        type: 'bar', //
        labels: { //
          format: (v) => { //
            return v + '%'; //
          } //
        }, //
        color: (color, d: any) => { //
          return this.colorList[d.index]; //
        } //
      }, //
      legend: { //
        show: false //
      }, //
      axis: { //
        x: { //
          type: 'category', //
          label: {
            text: 'Classification',
            position: 'outer-center'
          },
          tick: { //
            centered: true, //
          }, //
        },
        y: { //
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          tick: { //
            format(val) { return val + '%'; } //
          } //
        } //
      }, //

      bar: { //
        width: { //
          ratio: .8 //
        }
      },
      tooltip: {
        show: false
      }

      // tooltip: {
      //   format: {
      //     title: function (d) { return 'Cost Contribution'; },
      //     value: function (value, ratio, id) {
      //       return String(value);
      //     }
      //   }
      // }

    });
  }

  popupGraph() {
    this.dialog.open(BarChartPopupComponent, {
      width: '840px',
      height: '500px',
      data: {
        data: this.data
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.costContributionByABCDSubscription) {
      this.costContributionByABCDSubscription.unsubscribe();
    }
  }

}
